import { createContext } from "react";

export interface CubeContextType {
  cubeCompanySlug: string | null;
}

export const CubeContext = createContext<CubeContextType>(
  {} as unknown as CubeContextType,
);
